import { render, staticRenderFns } from "./ListTableMetadataColsComponent.vue?vue&type=template&id=85519472&scoped=true&lang=pug"
import script from "./ListTableMetadataColsComponent.vue?vue&type=script&lang=js"
export * from "./ListTableMetadataColsComponent.vue?vue&type=script&lang=js"
import style0 from "./ListTableMetadataColsComponent.vue?vue&type=style&index=0&id=85519472&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85519472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85519472')) {
      api.createRecord('85519472', component.options)
    } else {
      api.reload('85519472', component.options)
    }
    module.hot.accept("./ListTableMetadataColsComponent.vue?vue&type=template&id=85519472&scoped=true&lang=pug", function () {
      api.rerender('85519472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/components/ListTableMetadataColsComponent.vue"
export default component.exports